import { Component } from "@angular/core";

@Component({
    selector: "vds-turbine-spinner",
    templateUrl: "./turbine-spinner.component.html",
    styleUrl: "./turbine-spinner.component.css",
    standalone: true
})
export class TurbineSpinnerComponent {}
